<template>
  <h1
    v-html="block.data.text"
    class="width-100-pr"
  >
  </h1>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockTitle1',

  props: {
    block: Object
  }
}
</script>
